import React from "react";
import PropTypes from "prop-types";
import * as UU5 from "uu5g04";
import "uu5g04-forms";
import createReactClass from "create-react-class";

import ns from "ns";

import Lsi from "../config/lsi.js";

export const Block = createReactClass({
  //@@viewOn:mixins
  mixins: [
    UU5.Common.BaseMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: ns.tag("BricksEditable.Block"),
    nestingLevelList: UU5.Environment.getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: "editable-block"
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    component: PropTypes.object
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      component: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState() {
    // get data for form from component
    let temp = {};
    if (typeof this.props.component.getEditablePropsValues === "function") {
      temp = this.props.component.getEditablePropsValues(["icon", "content", "children"]);
    }
    temp.type = "BasicEdit";
    return temp;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _isFalsy(elem) {
    switch (elem) {
      case null: return true;
      case undefined: return true;
      case "": return true;
      case 0: return true;
      default: return false;
    }
  },
  _checkValues(prev, next) {
    let output = { ...next };
    for (let elem in next) {
      if (next[elem] === prev[elem] || (this._isFalsy(next[elem]) && this._isFalsy(prev[elem]))) {
        delete output[elem];
      }
    }
    return output;
  },
  _save(form) {
    let props = form.values;
    props.icon = props.icon ? props.icon.trim() : "";
    props.contentEditable = true;
    if (props.content) {
      if (props.content !== this.state.children) {
        let content = this._contentToString(props.content);
        props.content = content ? "<uu5string/>" + content : content;
        if (this.state.children) props.children = "";
      } else {
        delete props.content;
      }
    }
    const preProps = this.props.component.getEditablePropsValues(["icon", "contentEditable", "content", "children"]);
    props = this._checkValues(preProps, props);
    this.props.component.endEditation(props);
  },


  _cancel() {
    this.props.component.endEditation();
  },

  //TODO
  //change content type to uu5stringWithButton when its ready in uu5
  _getBasicEdit(content) {
    let props = [
      {
        name: "icon",
        type: "text",
        label: this.getLsiItem(Lsi.blockEditableLabelIcon),
        placeholder: this.getLsiItem(Lsi.blockEditableIconPlaceholder),
        value: this.state.icon
      },
      {
        name: "content",
        type: "uu5string",
        label: this.getLsiItem(Lsi.blockEditableLabelText),
        value: content,
        maxRows: 1000,
        rows: 5,
        showGutter: false,
        wrapEnabled: true,
        labelColWidth: "xs-12",
        inputColWidth: "xs-12",
        icon: "mdi-arrow-expand",
        props: {ref_: input => this._input = input, disabled:true}
      },
      {
        name: "contentEditable",
        type: "bool",
        label: "Content Editable",
        value: true,
        props: {onChange: opt => {
          opt.component.setValue(opt.value);
          if (this._input) {
            opt.value ? this._input.disable() : this._input.enable();
          }
        }}
      }
    ];
    return (
      <UU5.Bricks.Div {...this.getMainPropsToPass()}>
        <UU5.Forms.PropsForm
          onSave={this._save}
          onCancel={this._cancel}
          labelColWidth="xs-12"
          inputColWidth="xs-12"
          props={props}
          uu5string={true}
          id={UU5.Common.Tools.generateUUID()}
        />
      </UU5.Bricks.Div>
    );
  },

  _getChild() {
    let content = this.state.children || this._contentToString(this.state.content);
      return this._getBasicEdit(content);
  },

  _contentToString(content) {
    if (content) {
      if (Array.isArray(content)) {
        return content.join(" ").replace(UU5.Common.REGEXP.uu5string, "");
      }
      return content.replace(UU5.Common.REGEXP.uu5string, "");
    }
    return "";
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render() {
    return this._getChild();
  }
  //@@viewOff:render
});

export default Block;



// WEBPACK FOOTER //
// ./bricks-editable/block.js